import React from 'react';
import { styled } from '@mui/material/styles';
import MuiBottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import KeyIcon from '@mui/icons-material/Key';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import useCanAccess from '../../hooks/useCanAccess';

const NavPaper = styled(Paper)(({ theme }) => `
    bottom: 0;
    border-top: 1px solid ${theme.palette.divider};
    display: none;
    left: 0;
    position: fixed;
    right: 0;
    z-index: ${theme.zIndex.appBar};

    ${theme.breakpoints.down('md')} {
        display: block;
    }
`);

const BottomNavigation = styled(MuiBottomNavigation)(({ theme }) => `
    background-color: ${theme.palette.background.paper};
`);

export default function BottomNav() {
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation('common');
    const { userInfo } = useAuth();
    const { canAccessPage } = useCanAccess();

    const getActiveValue = () => {
        const path = location.pathname;
        if (path === '/' || path === '/dashboard') return 'dashboard';
        if (path.startsWith('/search')) return 'search';
        if (path.startsWith('/reports')) return 'reports';
        if (path.startsWith('/administration')) return 'administration';
        return 'dashboard';
    };

    return (
        <NavPaper elevation={0}>
            <BottomNavigation value={getActiveValue()} showLabels>
                {canAccessPage('DASHBOARD') && (
                    <BottomNavigationAction
                        label={t('navbar.dashboard')}
                        value="dashboard"
                        icon={<ShowChartIcon />}
                        onClick={() => navigate('/')}
                    />
                )}
                <BottomNavigationAction
                    label={t('navbar.search')}
                    value="search"
                    icon={<SearchIcon />}
                    onClick={() => navigate('/search')}
                />
                {userInfo?.canAccessReports && canAccessPage('REPORTS') && (
                    <BottomNavigationAction
                        label={t('navbar.reports')}
                        value="reports"
                        icon={<FormatListBulletedIcon />}
                        onClick={() => navigate('/reports')}
                    />
                )}
                {userInfo?.canAccessAdministration && canAccessPage('ADMINISTRATION') && (
                    <BottomNavigationAction
                        label={t('navbar.administration')}
                        value="administration"
                        icon={<KeyIcon />}
                        onClick={() => navigate('/administration')}
                    />
                )}
            </BottomNavigation>
        </NavPaper>
    );
}
